(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("KEditor"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["KEditor", "jQuery"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("KEditor"), require("jQuery")) : factory(root["KEditor"], root["jQuery"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__30__) {
return 